import { render, staticRenderFns } from "./CopyrightWarning.vue?vue&type=template&id=82687f9c&scoped=true"
import script from "./CopyrightWarning.vue?vue&type=script&lang=js"
export * from "./CopyrightWarning.vue?vue&type=script&lang=js"
import style0 from "./CopyrightWarning.vue?vue&type=style&index=0&id=82687f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82687f9c",
  null
  
)

export default component.exports